import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postProjectsProjectIDJobs } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useCreateJobMutation(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (name: string) => postProjectsProjectIDJobs({ name }, projectId),
      { translationPrefix: getResourcePath(Resources.ApiErrors.CreateJob) },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobs(projectId),
      });
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.detail(projectId),
      });
    },
  });
}
